export enum CustomInsightStatus {
  Disabled = 0,
  Active = 1,
  Pending = 2,
}

export interface CustomInsight {
  created_at: string
  call_to_action: string
  description: string
  final_generated_count: number
  status: CustomInsightStatus
  title: string
}

// All fields are optional since they are created during different steps of the wizard
export interface NewCustomInsight {
  action?: string
  attribute?: string
  call_to_action?: string
  call_to_action_link?: string
  call_to_action_post_message_link_text?: string
  call_to_action_post_message_configuration?: string
  condition?: string
  description?: string
  object?: string
  title?: string
}

export interface CustomInsights extends Array<CustomInsight> {}
